import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Pompiste } from '@/types';

interface PompisteState {
  pumpistes: Pompiste[];
}

const initialState: PompisteState = { pumpistes: [] };

const pompisteSlice = createSlice({
  name: 'pompiste',
  initialState,
  reducers: {
    setPompistes(state, action: PayloadAction<Pompiste[]>) {
      state.pumpistes = action.payload;
    },
    addPompiste(state, action: PayloadAction<Pompiste>) {
      state.pumpistes.push(action.payload);
    },
    removePompiste(state, action: PayloadAction<Pompiste>) {
      state.pumpistes = state.pumpistes.filter((p) => p.id !== action.payload.id);
    },
    editPompiste(state, action: PayloadAction<Pompiste>) {
      const i = state.pumpistes.findIndex((p) => p.id === action.payload.id);
      if (i !== -1) state.pumpistes[i] = action.payload;
    },
  },
});

export const { setPompistes, addPompiste, removePompiste, editPompiste } = pompisteSlice.actions;
export default pompisteSlice.reducer;
